<div class="loader-overlay">
  <div class="loader-overlay-content">
    <i class="fa-light fa-loader loading-spinner" aria-hidden="true"></i>
  </div>
</div> 